import React from "react";
import { shapeOptions } from "components/common/TagsShapes/TagsShapes";
import { getAdjustedFontSize } from "../Common/StylesHelper";

const PublicTagShape = ({
  shape,
  color = "#A47E51",
  name,
  styles,
  width = 76,
  height = 76,
}) => {
  const tagShapeObj = shapeOptions?.find((s) => s.id === shape);
  const { size, family, color: textColor } = styles?.tags || {};

  if (!tagShapeObj) return null;

  const { className = "" } = tagShapeObj || {};

  const getStyles = {
    color: textColor,
    fontFamily: family,
    fontSize: getAdjustedFontSize(10, family),
  };

  return (
    <div className={`common_shape_tag ${className}`}>
      <div className="shape_tag_wrapper">
        {tagShapeObj.shapeType({
          color,
          width,
          height,
          label: name,
          labelStyle: getStyles,
        })}
      </div>
    </div>
  );
};

export default PublicTagShape;
